import { Fragment, useState, useEffect } from 'react'
import { KYC_STATUSES } from './constants'
import { useDispatch } from 'react-redux'
import { Card } from 'react-bootstrap'
import config from '../../config'
import Cookies from 'js-cookie'
import KYCUserModal from './components/KYCUserModal'
import KYCSearch from './components/KYCSearch'
import KYCTable from './components/KYCTable'
import KYCDropdownStatus from './components/KYCDropdownStatus'
import KYCPagination from './components/KYCPagination'
import KYCManualModal from './components/KYCUserModal/KYCManualModal'
import { getKycById } from './services'
import Swal from 'sweetalert2'

export default function KYC() {
  const [kyc, setKYC] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [userNo, setUserNo] = useState('')
  const [phoneNo, setPhoneNo] = useState('')
  const [status, setStatus] = useState(KYC_STATUSES.PENDING)
  const dispatch = useDispatch()
  const [kycUserModalVisible, setKYCUserModalVisible] = useState(false)
  const [isShowManualModal, setIsShowManualModal] = useState(false)
  const [selectedKYCUser, setSelectedKYCUser] = useState({})
  const [pagination, setPagination] = useState({
    page: 1,
    hasNext: false,
  })

  const fetchKYC = async () => {
    try {
      dispatch({ type: 'loading_show' })
      const params = new URLSearchParams({
        status: status,
        page: currentPage,
        limit: 10,
      })
      if (userNo) {
        params.append('userNo', userNo.toUpperCase())
      }
      if (phoneNo) {
        params.append('phone', phoneNo)
      }

      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/kyc?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error(response.status.description)

      setKYC(response.data)
      setPagination((pagination) => ({
        ...pagination,
        hasNext: response.pagination.hasNext,
      }))
    } catch (error) {
      setKYC([])
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const handleCreateKyc = async (kycId) => {
    setIsShowManualModal(false)

    try {
      dispatch({ type: 'loading_show' })

      const data = await getKycById(kycId)

      setSelectedKYCUser(data)
      setKYCUserModalVisible(true)
    } catch (error) {
      console.error(error)
      Swal.fire('ไม่สามารถยืนยันตัวตนได้', 'กรุณาลองใหม่อีกครั้ง')
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    setCurrentPage(1)
    fetchKYC()
  }, [status])

  useEffect(() => {
    fetchKYC()
  }, [currentPage])

  const onEnterSearch = (e) => {
    e.preventDefault()
    setStatus(KYC_STATUSES.UNKNOWN)
    fetchKYC()
    setCurrentPage(1)
  }

  const onClickClear = () => {
    setUserNo('')
    setPhoneNo('')
    setPagination({ page: 1, hasNext: false })
    setStatus(KYC_STATUSES.PENDING)
    setCurrentPage(1)
  }

  const onCloseKYCUserModal = () => {
    setKYCUserModalVisible(false)
    setSelectedKYCUser({})
    fetchKYC()
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>KYC</Card.Title>
          <button className="btn btn-primary" onClick={() => setIsShowManualModal(true)}>
            ยืนยันตัวตนใหม่
          </button>
        </Card.Header>
        <Card.Body>
          <div className="my-2">
            <KYCSearch
              userNo={userNo}
              setUserNo={setUserNo}
              phoneNo={phoneNo}
              setPhoneNo={setPhoneNo}
              onEnterSearch={onEnterSearch}
              onClickClear={onClickClear}
            />
          </div>
          <div className="my-2">
            <KYCDropdownStatus status={status} setStatus={setStatus} />
          </div>
          <div className="my-2">
            <KYCTable
              kyc={kyc}
              setSelectedKYCUser={setSelectedKYCUser}
              setKYCUserModalVisible={setKYCUserModalVisible}
            />
          </div>
          <div className="my-2">
            <KYCPagination pagination={pagination} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </Card.Body>
      </Card>
      {kycUserModalVisible && (
        <KYCUserModal
          kycUserModalVisible={kycUserModalVisible}
          setKYCUserModalVisible={setKYCUserModalVisible}
          selectedKYCUser={selectedKYCUser}
          setSelectedKYCUser={setSelectedKYCUser}
          onClose={onCloseKYCUserModal}
        />
      )}
      {isShowManualModal && (
        <KYCManualModal
          isOpen={isShowManualModal}
          onDataCreated={handleCreateKyc}
          onClose={() => setIsShowManualModal(false)}
        />
      )}
    </Fragment>
  )
}
